/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { classNames } from '#utils/UNSAFE_classNames';
import { styles } from './themes/VisTabularDatatipStyles.css';
import { useUser } from '#hooks/UNSAFE_useUser';

export type TableRowData = {
  key: string;
  value: string | number;
};
type Props = {
  tableData: Array<TableRowData>;
};

export function VisTabularDatatip({ tableData }: Props) {
  const { direction } = useUser();
  const isRtl = direction === 'rtl';
  const datatipLabelStyle = classNames([
    styles.VisTabularDatatipLabel,
    isRtl ? styles.leftAlign : styles.rightAlign
  ]);
  const datatipValueStyle = classNames([
    styles.VisTabularDatatipValue,
    isRtl ? styles.rightAlign : styles.leftAlign
  ]);

  return (
    <table class={styles.VisTabularDatatipTable}>
      <tbody>
        {tableData.map(({ key, value }) => {
          return (
            <tr>
              <td class={datatipLabelStyle}>{key}</td>
              <td class={datatipValueStyle}>{value}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
